import { get } from "lodash";
import { MdClose } from "react-icons/md";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import Button from "../../../../Button";
import Stars from "../../../../Stars";
function View({ onSubmit, onClose, generalCost, upsells, totalAmount }) {
  const planName = get(generalCost, "insurancePlan.name") || "";
  const currency = get(generalCost, "currency");
  const stars =
    parseInt(
      String(get(generalCost, "insurancePlan.alias")).replace(/\D/g, ""),
    ) || 1;
  const currencySymbol = CURRENCY_SYMBOL[currency] || CURRENCY_SYMBOL.EUR;
  const [integer = "0", decimal = "00"] = costToFrench(get(generalCost, "cost"))
    ?.toString()
    ?.split(",") || ["-"];
  const annualAmount = (parseFloat(get(generalCost, "cost")) * 12).toFixed(2);
  const [annualInteger = "0", annualDecimal = "00"] = costToFrench(annualAmount)
    ?.toString()
    ?.split(",") || ["-"];

  return (
    <div className="mobilityMutual__cart-modal">
      <div className="mobilityMutual__cart-modal__card">
        <div className="mobilityMutual__cart-modal__header">
          <div className="mobilityMutual__cart-modal__header-left">
            <div className="mobilityMutual__cart-modal__stars">
              <Stars count={stars} />
            </div>
            <div className="mobilityMutual__cart-modal__plan-name">
              {planName}
            </div>
          </div>
          <div className="mobilityMutual__cart-modal__header-right">
            <div className="mobilityMutual__cart-modal__price">
              <span className="mobilityMutual__cart-modal__price-value">
                {integer}
                {decimal !== "00" && (
                  <span className="mobilityMutual__cart-modal__price-decimal">
                    ,{decimal}
                  </span>
                )}
              </span>
              <span className="mobilityMutual__cart-modal__price-currency">
                {" "}
                {currencySymbol} /mois
              </span>
            </div>
            <div className="mobilityMutual__cart-modal__price-annual">
              {annualInteger}
              {annualDecimal !== "00" && `,${annualDecimal}`} {currencySymbol}{" "}
              par an
            </div>
          </div>
        </div>
      </div>
      {upsells.length > 0 && (
        <div className="mobilityMutual__cart-modal__upsell">
          {upsells.map(({ insurancePlan: { name, alias }, cost, currency }) => {
            const upsellStars = parseInt(String(alias).replace(/\D/g, "")) || 1;
            return (
              <div
                className="mobilityMutual__cart-modal__upsell--card"
                key={name}
              >
                <div className="mobilityMutual__cart-modal__upsell--card--left">
                  <h3>{name}</h3>
                  <Stars count={upsellStars} />
                </div>
                <div className="mobilityMutual__cart-modal__upsell--card--right">
                  <span>
                    +{costToFrench(cost)} {CURRENCY_SYMBOL[currency] || ""}
                  </span>
                  /mois
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="mobilityMutual__cart-modal__actions">
        <Button type="primary-light" onClick={onClose}>
          <MdClose size={18} />
          Fermer
        </Button>
        <Button type="primary" onClick={onSubmit} width="100%">
          Modifier
        </Button>
      </div>
    </div>
  );
}

export default View;
